import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
export default class GetAssociatedTeams extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-getAssociatedTeams',
      payload: {
        ...this._payload
      }
    });
  }

  onSuccess(data) {
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          associatedTeams: data,
        },
      },
    });
    super.onSuccess(data);
  }
}
